import { render, staticRenderFns } from "./FileManagerEditFolderComponent.vue?vue&type=template&id=0ce78702&scoped=true&lang=pug"
import script from "./FileManagerEditFolderComponent.vue?vue&type=script&lang=ts"
export * from "./FileManagerEditFolderComponent.vue?vue&type=script&lang=ts"
import style0 from "./FileManagerEditFolderComponent.vue?vue&type=style&index=0&id=0ce78702&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce78702",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ce78702')) {
      api.createRecord('0ce78702', component.options)
    } else {
      api.reload('0ce78702', component.options)
    }
    module.hot.accept("./FileManagerEditFolderComponent.vue?vue&type=template&id=0ce78702&scoped=true&lang=pug", function () {
      api.rerender('0ce78702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/FileManagerEditFolderComponent.vue"
export default component.exports